import { reactive } from 'vue'

const state = reactive({ open: false, query: '' })

export function useGlobalSearch() {
  return {
    state,
    open: (query = '') => { state.query = query; state.open = true },
    close: () => { state.open = false; state.query = '' }
  }
}
